import AssesmentForDataEngineer from '../../views/AssesmentForDataEngineer';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { actions } from '../../../state/assessment';
import { actions as assessmentactions } from '../../../state/assessment';


const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view || 'source',
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  name: state.shift.auth.name,
  username: state.shift.auth.username,
  projectList: state.shift.assessment.RepositoryNameList,
  projectListfordataen: state.shift.assessment.RepositoryNameListfordataen,
  clientname: state.shift.assessment.clientname,
  opportunity_num: state.shift.assessment.opportunity_num,
  reponame: state.shift.assessment.reponame,
  reponamefordataen: state.shift.assessment.reponamefordataen,
  srclang: state.shift.assessment.srclang,
  tgtlang: state.shift.assessment.tgtlang,
  description: state.shift.assessment.description,
  role: state.shift.auth.role,
  flag:state.shift.assessment.flag
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;
  let isClicked1 = true;
  return {
    clickBackHandler: value => {
      // console.log(value);
      dispatch(push(`/${locale}/shift`));
      //dispatch(assessmentactions.resetAssessmentStore());
    },

    clickSubmitHandler: (
      reponamefordataen,
      reponame,
      srclang,
      tgtlang,
      description,
      opportunity_num,
      clientname,
      username,
      name
    ) => {
      if (isClicked1){

            setTimeout(() => {      

              isClicked1 = true;

              }, 5000);


      dispatch(
        actions.assessmentfordatasubmit(
          reponamefordataen,
          reponame,
          //srclang,
          JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['srclang'],
          tgtlang,
          //description,
          JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['description'],
         // opportunity_num,clientname
         JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['opportunity_num'],
          //clientname,
          JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['clientname'],
          username,
          name
        )
      ).then(() => dispatch(push(`/${locale}/resultmsgpage`)))

      isClicked1 = false;
      console.log("calling...")

     }
  },




  getinfobyreponameforaccessment: event => {

  const old_clientname = JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['clientname'];
  const old_opp_num = JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['opportunity_num'];
  const old_srclang = JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['srclang'];


  dispatch(actions.getinfobyreponameforaccessment({ value: event.target.value }.value));


  function disableButton(){
      const new_clientname = JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['clientname'];
      const new_opp_num = JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['opportunity_num'];
      const new_srclang = JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['srclang'];

      setTimeout(() => {
          if(old_clientname != new_clientname && new_clientname!=null){
            dispatch(actions.setflag(new_clientname.length==0));
              return;
            }

            if(old_clientname != new_clientname && new_clientname == null ){
              dispatch(actions.setflag(true));
              return;

           }

          if(old_opp_num != new_opp_num){
                        dispatch(actions.setflag(new_opp_num !=null && new_opp_num.length==0));
                          return;
           }

           if(old_opp_num != new_opp_num && new_opp_num == null){
            dispatch(actions.setflag(true));
            return;
         }

        // if(new_opp_num == ''){
            //alert(JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['opportunity_num'])
          if (JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['opportunity_num'] == null){
                  dispatch(actions.setflag(true));
                  return;
          }
          // }else{

          //   dispatch(actions.setflag(false));
          // }


       //}

           if(old_srclang  != new_srclang &&  new_srclang == null ){
            dispatch(actions.setflag( true));
             return;
          }

           if(old_srclang  != new_srclang ){
                dispatch(actions.setflag( new_srclang ==''));
              return;
           }
      disableButton ();
      }, 500);
      }
      disableButton ();
      },

      desHandlerHandler: event => {
        dispatch(actions.changeds({ value: event.target.value }.value));
      },

      srcChangeHandlerHandler: event => {
        dispatch(actions.changesrc({ value: event.target.value }.value));
        if (JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['clientname'] !=null
        && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['clientname'].length>0
        && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['opportunity_num'] != null
        && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['opportunity_num'].length>0
            ){
                 dispatch(actions.setflag(false));
            }
       if({ value: event.target.value }.value ==""){
            dispatch(actions.setflag(true));
          }
      },

      oppnumChangeHandler: event => {

        dispatch(actions.changeoppnum({ value: event.target.value }.value));
            if (JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['clientname'] != null
                  && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['clientname'].length>0
                  && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['srclang'] != null
                  && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['srclang'] != ""
            ){
                 dispatch(actions.setflag(false));
            }
// for the existing data case remove data
            if({ value: event.target.value }.value == ""  ){
                dispatch(actions.setflag(true));
            }
      },

      clientnameChangeHandler:event => {

        dispatch(actions.changeclientname({ value: event.target.value }.value));
        if (JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['opportunity_num'] != null
        && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['opportunity_num'].length>0
        && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['srclang'] != null
        && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['srclang'] != ""
        ){
          dispatch(actions.setflag(false));
         }

      },
};

}
const AssesmentForDataEngineerComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssesmentForDataEngineer);

export default AssesmentForDataEngineerComponent;



// WEBPACK FOOTER //
// ./src/components/container/AssesmentForDataEngineer/index.js